// The point of this document is for development process
export const ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP = {
  AAHKV2X7AFYLW: 'en-US',
  ATVPDKIKX0DER: 'en-US'
};

export const marketPlaceStyleMap = { AAHKV2X7AFYLW: 'en', ATVPDKIKX0DER: 'en' };
